// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"bd8f78f4","569":"fb7fa348","766":"5267a031","782":"23807a6c","877":"d891d9c8","901":"8a5b0b61"}[chunkId] + ".chunk.css";
};